// extracted by mini-css-extract-plugin
export default {"root":"bookings_to_reassign_selector-module___root___c8d77f52"};